module.exports = __webpack_public_path__ + "img/casa-artesao.219c9c08.jpg";